module.exports = __webpack_public_path__ + "static/media/styledmenu-arrow-up.6040828a.svg";